import { render } from "./FoodCard.vue?vue&type=template&id=6db12832&scoped=true"
import script from "./FoodCard.vue?vue&type=script&lang=js"
export * from "./FoodCard.vue?vue&type=script&lang=js"

import "./FoodCard.vue?vue&type=style&index=0&id=6db12832&scoped=true&lang=css"

import exportComponent from "/vercel/path0/my_res/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db12832"]])

export default __exports__